import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import AddContact from "../../../Contacts/AddContact";
import "./contactEdit.scss";
import { proxyAPI } from "../../../proxyAPI";
import {
  closeModal,
  selectCurrentModal,
  selectModalData,
} from "../../../store/slices/modalsSlice";

export default function ContactEditModal() {
  const [contact, setContact] = useState(null);
  const dispatch = useDispatch();
  const handleClose = () => {
    dispatch(closeModal());
  };

  const modal = useSelector(selectCurrentModal);
  const editedContactData = useSelector(selectModalData) || {};

  const getContact = async () => {
    const data = await proxyAPI({
      prefix: "contacts/v1",
      url: `/first/${editedContactData.contact.uuid}?fields.primary=1&fields.uuids=email&fields.uuids=phone&fields.cards=1&fields.channels=1&fields.hidden=1`,
    });

    setContact(data || editedContactData.contact);
  };

  return (
    <Modal
      size="xl"
      show={modal === "editContact"}
      onHide={handleClose}
      onEnter={getContact}
      className="z-contact-edit edit-contact-modal"
      backdropClassName="z-contact-edit-backdrop edit-contact-modal-backdrop"
    >
      <Modal.Header closeButton>
        <Modal.Title>Edit contact</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {contact && <AddContact key={contact?.uuid} editedContact={contact} />}
      </Modal.Body>
    </Modal>
  );
}
